import { useSyncExternalStore } from "react";

/**
 * Tiny external store for "the session has expired and could not be refreshed". `apiJson`
 * flips it on a persistent `401`; the app shell subscribes and shows the ReloadPrompt
 * (US-A3 — re-mint the iframe). Kept outside React so the non-React fetch layer can set it.
 */
let expired = false;
const listeners = new Set<() => void>();

export function markSessionExpired(): void {
  if (expired) return;
  expired = true;
  for (const l of listeners) l();
}

/** Test-only reset so suites don't leak the flag between cases. */
export function resetSessionExpired(): void {
  expired = false;
}

export function useSessionExpired(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => expired,
    () => expired,
  );
}
